import React from "react";
import { certifications } from "../data/portfolio";

const MsFlag = () => (
  <div className="grid grid-cols-2 gap-[2px]" aria-hidden="true">
    <span className="h-4 w-4 bg-[#f25022]" />
    <span className="h-4 w-4 bg-[#7fba00]" />
    <span className="h-4 w-4 bg-[#00a4ef]" />
    <span className="h-4 w-4 bg-[#ffb900]" />
  </div>
);

const CertificationsWindow = () => {
  return (
    <div className="flex h-full flex-col bg-[#c0c0c0] font-ui text-win-text">
      <div className="px-3 pt-3">
        <p className="text-sm font-bold">Completed credentials and what I am currently working on.</p>
        <p className="mt-1 max-w-xl text-xs leading-5 text-[#404040]">
          I do not currently hold certifications, but I am actively taking and planning the ones that best
          support my interest in cloud computing and infrastructure.
        </p>
      </div>

      <div className="mt-3 grid flex-1 auto-rows-min grid-cols-1 gap-3 overflow-auto p-3 sm:grid-cols-2">
        {certifications.map((certification) => (
          <article key={certification.title} className="win-raised flex flex-col items-center gap-2 p-4 text-center">
            <div className="win-sunken-thin flex h-14 w-14 items-center justify-center">
              <MsFlag />
            </div>
            <span className="win-sunken-thin px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-win-navy">
              {certification.status}
            </span>
            <h3 className="text-sm font-black leading-tight">{certification.title}</h3>
            <p className="text-xs font-bold text-[#404040]">{certification.code}</p>
          </article>
        ))}
      </div>
    </div>
  );
};

export default CertificationsWindow;
